/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'

import { Table } from 'semantic-ui-react'

import utils from '../../../utils'

import ExpressRow from './ExpressRow'
import ModalEditNote from '../../../components/express/ModalEditNote'

import OrderActions from '../../../reducers/orderReducer'
import MapViewActions from '../../../reducers/mapViewReducer'

class ExpressList extends React.PureComponent {
  state = {
    modalEditNoteVisible: false,
    modalEditNoteData: null,
  }

  showEditNote = order => {
    this.setState({ modalEditNoteVisible: true, modalEditNoteData: order })
  }

  dismissModalEditNote = () => {
    this.setState({ modalEditNoteVisible: false, modalEditNoteData: null })
  }

  renderHeader = () => {
    const headers = [
      { col: 'Sender / Receiver', width: '20%', align: 'left' },
      { col: 'Driver / Location', width: '20%', align: 'center' },
      { col: 'Payment', width: '20%', align: 'center' },
      { col: 'Ordered At', width: '20%', align: 'center' },
      { col: 'Type / Status / Actions', width: '20%', align: 'center' },
    ]

    return (
      <Table.Row>
        {headers.map(header => (
          <Table.HeaderCell style={{ width: header.width }} textAlign={header.align} key={header.col}>
            {header.col}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    )
  }

  showLiveTracking = order => {
    const { setMapData } = this.props

    const receiverLocations = _.chain(order.receivers)
      .map((receiver, key) => ({ ...receiver, key }))
      .orderBy('order_number')
      .value()
    const merchantLocation = order.pickup_location

    const data = {
      merchantLocation,
      receiverLocations,
      driverUid: order.deliverer,
      merchantName: order.sender_name,
    }

    setMapData('express_live_tracking', data)
  }

  renderBody = () => {
    const { express, showManualAssign } = this.props

    const orders = Object.values(express)

    if (orders.length === 0)
      return (
        <Table.Row key="no-result">
          <Table.Cell colSpan={8} textAlign="center">
            No results
          </Table.Cell>
        </Table.Row>
      )

    return orders.map(order => {
      return (
        <ExpressRow
          key={order.id}
          showManualAssign={() => showManualAssign(order.id)}
          order={utils.order.getExpressOrderSummary(order)}
          showLiveTracking={() => this.showLiveTracking(order)}
          showEditNoteModal={() => this.showEditNote(order)}
        />
      )
    })
  }

  render() {
    const { modalEditNoteData, modalEditNoteVisible } = this.state

    return (
      <React.Fragment>
        <Table basic selectable>
          <Table.Header>{this.renderHeader()}</Table.Header>
          <Table.Body>{this.renderBody()}</Table.Body>
        </Table>

        <ModalEditNote
          visible={modalEditNoteVisible}
          order={modalEditNoteData}
          onCancel={this.dismissModalEditNote}
        />
      </React.Fragment>
    )
  }
}

const mapDispatch = {
  showOrderMap: OrderActions.showOrderMap,
  setMapData: MapViewActions.setMapData,
}

export default connect(
  null,
  mapDispatch
)(ExpressList)



// WEBPACK FOOTER //
// ./src/containers/express/components/ExpressList.js